<script>
import NkPage from '@/components/NkPage/NkPage.vue';

export default {
  components: { NkPage },
};
</script>
<template>
  <NkPage loading />
</template>
